import {useMemo} from 'react';
import {currencyFormat, dateShortFormat} from '../../utils';

export function ReservationRoomRow({reservationRoom, hasServices, isLast, isSelected, isInvoiced, onClick}) {
    const className = `reservation-rooms__room select vertical-align-start ${!hasServices ? 'reservation-rooms__room--no-products' : ''} ${isLast ? 'reservation-rooms__room--last' : ''} ${isSelected ? 'selected' : ''} ${isInvoiced ? 'danger' : ''}`;

    const stayPeriod = useMemo(() => {
        return dateShortFormat(reservationRoom.arrival) + ' - ' + dateShortFormat(reservationRoom.departure);
    }, [reservationRoom]);

    return <tr className={className} onClick={onClick}>
        <td className="col-xs-1 no-br">{reservationRoom.room_name}</td>
        <td className="col-xs-2 no-br">{reservationRoom.category_name}</td>
        <td className="col-xs-3 no-br">{stayPeriod}</td>
        <td colSpan="2" className="col-xs-4">{reservationRoom.guests.join(', ')}</td>
        <td className="col-xs-2 text-right no-br">
            <input type="hidden" name="room[]" value={reservationRoom.id}/>
            {currencyFormat(reservationRoom.gross)}
        </td>
    </tr>;
}
